module.exports = __webpack_public_path__ + "img/web@2x.80d6b4c6.png";